/* HealthyHeads — Advertorial secties
   - Vraagsecties: antwoord opslaan, markeren, automatisch naar het volgende anker
   - Resultaatsectie: verschijnt zodra alle vragen op de pagina beantwoord zijn
   - Antwoorden worden als URL-parameters meegegeven aan de knop in de resultaatsectie
*/
(function () {
  'use strict';

  var STORE_KEY = 'hh-adv-answers';
  var answers = {};

  /* ---------------------------------------------------------- opslag */
  try {
    var saved = sessionStorage.getItem(STORE_KEY);
    if (saved) answers = JSON.parse(saved) || {};
  } catch (e) { /* private mode: gewoon in het geheugen verder */ }

  function persist() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(answers)); } catch (e) {}
  }

  /* ---------------------------------------------------------- scroll */
  function scrollToId(id) {
    if (!id) return;
    var target = document.getElementById(id.replace(/^#/, ''));
    if (!target) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  /* -------------------------------------------------------- resultaat */
  function requiredKeys() {
    return Array.prototype.map.call(
      document.querySelectorAll('[data-hh-question]'),
      function (q) { return q.getAttribute('data-hh-key'); }
    ).filter(Boolean);
  }

  function buildUrl(base, params) {
    if (!base) return '#';
    var parts = [];
    Object.keys(params).forEach(function (k) {
      var v = params[k];
      if (v === undefined || v === null || v === '') return;
      parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });
    if (!parts.length) return base;
    return base + (base.indexOf('?') === -1 ? '?' : '&') + parts.join('&');
  }

  function collectParams() {
    var params = {};
    Object.keys(answers).forEach(function (k) {
      var a = answers[k];
      if (!a || !a.value) return;
      params[a.param || k] = a.value;
      if (a.extraParam && a.extraValue) params[a.extraParam] = a.extraValue;
    });
    return params;
  }

  function refreshResults() {
    var keys = requiredKeys();
    var complete = keys.length > 0 && keys.every(function (k) { return answers[k] && answers[k].value; });

    document.querySelectorAll('[data-hh-result]').forEach(function (sec) {
      var always = sec.getAttribute('data-hh-always') === 'true';
      var show = complete || always;
      var wasHidden = sec.hidden;
      sec.hidden = !show;
      if (!show) return;

      // Chips met de gegeven antwoorden.
      // We lopen door de vraagsecties zelf, zodat per vraag ingesteld kan worden
      // of het antwoord hier getoond wordt (bv. wel het gewicht, niet een ja/nee).
      var list = sec.querySelector('[data-hh-result-answers]');
      if (list) {
        list.innerHTML = '';
        document.querySelectorAll('[data-hh-question]').forEach(function (q) {
          if (q.getAttribute('data-hh-show-in-result') === 'false') return;
          var k = q.getAttribute('data-hh-key');
          if (!k || !answers[k]) return;
          var li = document.createElement('li');
          li.textContent = answers[k].label || answers[k].value;
          list.appendChild(li);
        });
        list.hidden = list.children.length === 0;
      }

      // Knop-URL met de antwoorden als parameters
      var btn = sec.querySelector('[data-hh-result-btn]');
      if (btn) {
        btn.setAttribute('href', buildUrl(btn.getAttribute('data-hh-base') || '', collectParams()));
      }

      if (wasHidden && complete && sec.getAttribute('data-hh-autoscroll') === 'true') {
        var anchorId = sec.getAttribute('data-hh-anchor') || sec.id;
        window.setTimeout(function () { scrollToId(anchorId); }, 120);
      }
    });
  }

  /* ----------------------------------------------------------- clicks */
  document.addEventListener('click', function (e) {

    // Antwoordknop
    var ans = e.target.closest('[data-hh-answer]');
    if (ans) {
      e.preventDefault();
      var section = ans.closest('[data-hh-question]');
      if (!section) return;
      var key = section.getAttribute('data-hh-key') || section.id;

      answers[key] = {
        value:      ans.getAttribute('data-hh-value') || '',
        label:      ans.getAttribute('data-hh-label') || ans.textContent.trim(),
        param:      section.getAttribute('data-hh-param') || key,
        extraParam: section.getAttribute('data-hh-extra-param') || '',
        extraValue: ans.getAttribute('data-hh-extra') || ''
      };
      persist();

      section.querySelectorAll('[data-hh-answer]').forEach(function (b) { b.classList.remove('is-selected'); });
      ans.classList.add('is-selected');

      refreshResults();

      // Doorschuiven: de bestemming op het antwoord wint van die op de sectie.
      // Begint hij met '#', dan scrollen we; anders is het een URL en gaan we
      // erheen — met de gegeven antwoorden als parameters, zodat de
      // voorselectie op de productpagina blijft werken.
      var next = ans.getAttribute('data-hh-next') || section.getAttribute('data-hh-next') || '';
      if (!next) return;

      if (next.charAt(0) === '#') {
        window.setTimeout(function () { scrollToId(next); }, 180);
      } else {
        var dest = buildUrl(next, collectParams());
        window.setTimeout(function () { window.location.href = dest; }, 180);
      }
      return;
    }

    // Elke CTA met een anker
    var link = e.target.closest('.hh-adv a[href^="#"]');
    if (link) {
      var id = link.getAttribute('href');
      if (id && id.length > 1 && document.getElementById(id.slice(1))) {
        e.preventDefault();
        scrollToId(id);
        if (history.replaceState) history.replaceState(null, '', id);
      }
    }
  });

  /* ------------------------------------------------------------- init */
  function boot() {
    // Eerder gegeven antwoorden opnieuw markeren
    document.querySelectorAll('[data-hh-question]').forEach(function (section) {
      var key = section.getAttribute('data-hh-key') || section.id;
      if (!answers[key]) return;
      section.querySelectorAll('[data-hh-answer]').forEach(function (b) {
        if (b.getAttribute('data-hh-value') === answers[key].value) b.classList.add('is-selected');
      });
    });
    refreshResults();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
